import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import type { BreadcrumbNode } from '@amplience/content-types/typings/h-breadcrumb-node';
import { maxWidthPartial, media, spacing } from '@storefront/lib-global/stylings';
import { GiftCardBalanceBreadcrumbNode } from './GiftCardBalanceBreadcrumbNode';

export type BreadcrumbDataType = {
  content: BreadcrumbNode;
};

type GiftCardBalanceBreadcrumbProps = {
  breadcrumbData: BreadcrumbDataType[];
};

const S = {
  Breadcrumb: styled.nav`
    display: none;

    @media ${media.greaterThan('lg')} {
      display: block;
      margin: ${spacing.M} 0 ${spacing.L};

      > ol {
        ${maxWidthPartial({ withPaddingXL: true })}
        display: flex;
        gap: ${spacing.XS};
      }
    }
  `,
};

export function GiftCardBalanceBreadcrumb({ breadcrumbData }: GiftCardBalanceBreadcrumbProps) {
  const { t } = useTranslation(['lib-products-common', 'lib-global-common']);
  const fallbackBreadcrumbData = [
    {
      content: {
        text: t('pdp.breadcrumbs.home'),
        link: '/',
        ranking: 1,
      },
    },
    {
      content: {
        text: t('gift.card.balance', { ns: 'lib-global-common' }),
        link: '/giftcardbalance',
        ranking: 2,
      },
    },
  ];
  const isFallbackBreadcrumbData = !breadcrumbData ? fallbackBreadcrumbData : breadcrumbData;

  return (
    <S.Breadcrumb>
      <ol>
        {isFallbackBreadcrumbData?.map((item, index) => (
          <GiftCardBalanceBreadcrumbNode key={`breadcrumb-${index}`} {...(item.content as unknown as BreadcrumbNode)} />
        ))}
      </ol>
    </S.Breadcrumb>
  );
}
